@if (!isMultipleEnabled) {
  <p-select
    #selector
    appDropDownValueExtender
    appDropdownFocusHandler
    [appDropdownExtender]="isCustomFilter"
    [options]="options"
    [placeholder]="
      placeholder ?? noSelectedMessage ?? ('label.no-items' | translate)
    "
    [filterPlaceholder]="filterPlaceholder"
    [appendTo]="appendTo"
    [(ngModel)]="selectedResult"
    (ngModelChange)="onOptionChanged()"
    [filter]="isFilterEnabled"
    (onFilter)="onFilterOptions($event)"
    [showClear]="isShowClearEnabled"
    [styleClass]="styleClass"
    [disabled]="disabled"
    (onBlur)="onBlured()"
    (onShow)="onShowed()"
    [emptyFilterMessage]="
      showLoading ? ('label.LOADING' | translate) : emptyFilterMessage
    "
    [emptyMessage]="showLoading ? ('label.LOADING' | translate) : emptyMessage"
    [required]="required"
    [autofocus]="autofocus"
    [panelStyleClass]="panelStyleClass"
    [filterBy]="filterBy"
    [autoDisplayFirst]="autoDisplayFirst"
    [group]="isGroupEnabled"
    [optionDisabled]="optionDisabled"
    [overlayOptions]="dropDownOverlayOption"
  >
    <ng-template let-item pTemplate="selectedItem">
      <ng-container
        *ngTemplateOutlet="
          _selectedItemTemplate || defaultItemTemplate;
          context: { $implicit: item }
        "
      >
      </ng-container>
    </ng-template>

    <ng-template let-item pTemplate="item">
      <ng-container
        *ngTemplateOutlet="
          _itemTemplate || defaultItemTemplate;
          context: { $implicit: item }
        "
      >
      </ng-container>
    </ng-template>

    <ng-template let-group pTemplate="group">
      <ng-container
        *ngTemplateOutlet="
          _groupTemplate || defaultGroupTemplate;
          context: { $implicit: group }
        "
      >
      </ng-container>
    </ng-template>

    <ng-template pTemplate="footer">
      <ng-container
        *ngTemplateOutlet="_footerTemplate || defaultFooter"
      ></ng-container>
    </ng-template>
    <ng-template pTemplate="emptyfilter">
      <ng-container *ngIf="!showLoading; else skeleton">
        {{ emptyFilterMessage }}</ng-container
      >
    </ng-template>
    <ng-template pTemplate="empty">
      <ng-container *ngIf="!showLoading; else skeleton">
        {{ emptyMessage }}</ng-container
      >
    </ng-template>
  </p-select>
  <input
    type="text"
    class="sr-only"
    [id]="inputId"
    tabindex="-1"
    aria-hidden="true"
    (focus)="selector.show()"
  />
} @else {
  <input
    type="text"
    class="sr-only"
    [id]="inputId"
    tabindex="-1"
    aria-hidden="true"
    (focus)="multipleSelect.show()"
  />

  <p-multiSelect
    #multipleSelect
    appDropDownValueExtender
    appMultiSelectFocusHandler
    [appMultiSelectExtender]="isCustomFilter"
    [options]="options"
    [placeholder]="
      placeholder ?? noSelectedMessage ?? ('label.no-items' | translate)
    "
    [filterPlaceHolder]="filterPlaceholder"
    [(ngModel)]="selectedResults"
    (ngModelChange)="onOptionChanged()"
    [filter]="isFilterEnabled"
    (onFilter)="onFilterOptions($event)"
    (onBlur)="onBlured()"
    [showClear]="isShowClearEnabled"
    [emptyFilterMessage]="
      showLoading ? ('label.LOADING' | translate) : emptyFilterMessage
    "
    [emptyMessage]="showLoading ? ('label.LOADING' | translate) : emptyMessage"
    [appendTo]="appendTo"
    [styleClass]="styleClass"
    [panelStyleClass]="panelStyleClass"
    [required]="required"
    [filterBy]="filterBy"
    [disabled]="disabled"
    [optionDisabled]="optionDisabled"
    [group]="isGroupEnabled"
    (onPanelShow)="onShowed()"
    [overlayOptions]="dropDownOverlayOption"
    [autofocus]="autofocus"
  >
    <ng-template pTemplate="selectedItems">
      <ng-container
        *ngTemplateOutlet="
          _selectedItemTemplate || defaultMultiSelectedItemTemplate;
          context: { $implicit: selectedResults }
        "
      />
    </ng-template>

    <ng-template let-item pTemplate="item">
      <ng-container
        *ngTemplateOutlet="
          _itemTemplate || defaultItemTemplate;
          context: { $implicit: item }
        "
      >
      </ng-container>
    </ng-template>

    <ng-template let-group pTemplate="group">
      <ng-container
        *ngTemplateOutlet="
          _groupTemplate || defaultGroupTemplate;
          context: { $implicit: group }
        "
      >
      </ng-container>
    </ng-template>

    <ng-template pTemplate="footer">
      <ng-container
        *ngTemplateOutlet="_footerTemplate || defaultFooter"
      ></ng-container>
    </ng-template>

    <ng-template pTemplate="emptyfilter">
      <ng-container *ngIf="!showLoading; else skeleton">
        {{ emptyFilterMessage }}</ng-container
      >
    </ng-template>
    <ng-template pTemplate="empty">
      <ng-container *ngIf="!showLoading; else skeleton">
        {{ emptyMessage }}</ng-container
      >
    </ng-template>
  </p-multiSelect>
}
<!-- Default Template -->
<ng-template let-item #defaultItemTemplate>
  <div
    class="flex items-center gap-2 {{ itemStyleClass }} select-dropdown-label"
    [attr.data-testid]="'item-' + (bindValue && getBoundedValue(item))"
  >
    <span
      class="entity-icon flex justify-center items-center"
      *ngIf="bindAvatar && getBoundedAvatar(item)"
    >
      <p-avatar
        [image]="getBoundedAvatar(item) | getLink | async"
        styleClass="mr-2"
        shape="circle"
      />
    </span>
    <span
      *ngIf="bindIcon && getBoundedIcon(item)"
      class="entity-icon flex justify-center items-center mr-2"
    >
      <p-avatar
        *ngIf="bindAvatar && !getBoundedAvatar(item)"
        [icon]="getBoundedIcon(item) | getIconCssClass"
        styleClass="mr-2"
        shape="circle"
      />
      <ng-container *ngIf="!bindAvatar">
        <i [ngClass]="getBoundedIcon(item) | getIconCssClass"></i>
      </ng-container>
    </span>
    <span class="app-select-padding">
      <div
        *ngIf="bindLabel && getBoundedLabel(item)"
        [class.selected-label]="
          (bindAvatar && getBoundedAvatar(item)) ||
          (bindIcon && getBoundedIcon(item) && bindAvatar)
        "
      >
        {{
          isString(getBoundedLabel(item)) &&
          isString(getBoundedLabel(item) | translate)
            ? (getBoundedLabel(item) | translate)
            : (getBoundedLabel(item) | propertyTranslator)
        }}
      </div>
      <div *ngIf="bindCaption && getBoundedCaption(item)">
        {{ getBoundedCaption(item) | propertyTranslator }}
      </div>
    </span>
  </div>
</ng-template>

<ng-template let-value #defaultMultiSelectedItemTemplate>
  <!-- TODO add translation -->
  <span *ngIf="selectedResultsLength > 0" class="{{ itemStyleClass }}">
    <ng-container *ngIf="!selectedMessage; else selectedMessageTpl">
      {{ "label.selectedRecords" | translate: { arg: selectedResultsLength } }}
    </ng-container>
    <ng-template #selectedMessageTpl>
      {{ selectedResultsLength }} {{ selectedMessage }}
    </ng-template>
  </span>
  <div *ngIf="!selectedResultsLength">
    {{ noSelectedMessage || ("label.no-items" | translate) }}
  </div>
</ng-template>

<ng-template let-item #defaultSingleSelectedItemTemplate>
  <div>
    <div class="flex items-center">
      <span class="mx-2">{{ item.toString() }}</span>
    </div>
  </div>
</ng-template>

<ng-template let-group #defaultGroupTemplate>
  <span
    *ngIf="getBoundedGroupLabel(group); else defaultGroupLabel"
    class="flex items-center {{ itemStyleClass }}"
  >
    {{ getBoundedGroupLabel(group) | propertyTranslator }}
  </span>
  <ng-template #defaultGroupLabel>
    <span class="flex items-center">{{ "label.GENERAL" | translate }}</span>
  </ng-template>
</ng-template>

<ng-template #defaultFooter></ng-template>

<ng-template #skeleton>
  <div class="flex items-center mb-2" *ngFor="let i of [1, 2, 3]">
    <p-skeleton
      shape="circle"
      size="30px"
      styleClass="mr-4"
      *ngIf="bindAvatar || bindIcon"
    ></p-skeleton>
    <p-skeleton
      width="100%"
      height="30px"
      styleClass="w-100"
      class="w-100"
    ></p-skeleton>
  </div>
</ng-template>
